import { ExaminationInfoQuery } from "@generated/graphql";
import { getTrialLinkString } from "helpers/index";
import useIsCreate from "hooks/useIsCreate";
import { getTestingBaseFormData } from "pages/Testing/utils/form.utils";
import qs from "qs";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { CompetencyMapOptionList } from "../../types";
import { GroupAndOpenInfoInputs } from "../types";

const useInitBaseExaminationForm = (
  examination: ExaminationInfoQuery["examination"] | undefined,
  competencyMaps: CompetencyMapOptionList
): GroupAndOpenInfoInputs => {
  const [searchParams] = useSearchParams();
  const isCreate = useIsCreate();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);
  const { competencyMapId } = params as unknown as { competencyMapId?: string };

  const competencyMap =
    isCreate && competencyMapId
      ? competencyMaps?.find((map) => map.id === competencyMapId)
      : examination?.competencyMap && {
          ...examination.competencyMap,
          id: examination.competencyMap.originalCompetencyMapId || "",
        };
  const assessmentLink = examination ? getTrialLinkString(examination) : undefined;

  return {
    ...getTestingBaseFormData(examination?.id, examination, competencyMap),
    link: assessmentLink,
    candidatesFile: undefined,
    sendReminder: examination?.sendReminder,
    reminderSchedule: examination?.reminderSchedule,
  };
};

export default useInitBaseExaminationForm;
